module.exports = __webpack_public_path__ + "static/media/sky-back@2x.3a34e51d.jpg";